import { Injectable, inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MailAdd, MailsService as ApiMailsService } from '@src/api';
import { AlertService } from '@src/core/services';

@Injectable({
  providedIn: 'root',
})
export class MailsService {
  private readonly mailsService = inject(ApiMailsService);
  private readonly alertService = inject(AlertService);

  sendSupportEmail(message: string, email: string, subject?: string, files?: File[]) {
    return this.mailsService.sendSupportMail(message, email, subject, files).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
    );
  }

  addMail(body?: MailAdd) {
    return this.mailsService.addMail(body).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
    );
  }

  editMail(body?: MailAdd) {
    return this.mailsService.editMail(body).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
    );
  }

  deleteMail(mailId: string) {
    return this.mailsService.deleteMail(mailId).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
    );
  }

  getMail(organisationId: string, email?: string) {
    return this.mailsService.getMail(organisationId, email).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
      map(v => v[0]),
    );
  }

  sendTestMail(callback?: (value: boolean) => void) {
    callback?.(true);

    return this.mailsService
      .sendTestMail()
      .pipe(
        catchError(err => {
          this.alertService.error(err);

          callback?.(false);
          return throwError(() => err);
        }),
      )
      .subscribe((res: any) => {
        //TODO: Убрать any после исправления типа ответа на string
        this.alertService.success(res);
        callback?.(false);
      });
  }
}
